"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingsContext = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
exports.UserSettingsContext = (0, react_1.createContext)({
    init: lodash_1.noop,
    getTableSettings: () => undefined,
    setTableSettings: lodash_1.noop,
    getCustomSettings: () => undefined,
    setCustomSettings: lodash_1.noop,
    clear: () => Promise.resolve(),
});
//# sourceMappingURL=user-settings-context.js.map